<template>
<div v-show="tableBaoSun.length>0">
  <el-card class="box-card" style="width: 960px;margin-top: 20px">
    <div slot="header" class="clearfix">
      <span>报损记录</span>
    </div>
    <el-table
      :data="tableBaoSun"
      size="mini"
      stripe
      border
      style="width: 940px;">
      <el-table-column
        prop="seedcode"
        label="编码"
        align="left" :show-overflow-tooltip="true"
        header-align="center" width="120">
      </el-table-column>
      <el-table-column
        prop="seedname" :show-overflow-tooltip="true"
        label="名称"
        align="left"
        header-align="center" width="200">
      </el-table-column>
      <el-table-column
        prop="packagesize"
        label="规格"
        align="left" :show-overflow-tooltip="true"
        header-align="center" width="150">
        <template slot-scope="scope">
          {{getPackagesize(scope.row.packagesize)}}
        </template>
      </el-table-column>
      <el-table-column
        prop="ordername"
        label="类别"
        align="left"
        header-align="center"
        width="80">
      </el-table-column>
      <el-table-column
        prop="remark"
        label="原因" :show-overflow-tooltip="true"
        align="left"
        header-align="center"
        width="200">
      </el-table-column>
      <el-table-column
        prop="ordernum"
        label="销售单号"
        align="left"
        header-align="center"
        width="120">
      </el-table-column>
      <el-table-column
        prop="buyordernum"
        label="采购单号"
        align="left"
        header-align="center"
        width="120">
      </el-table-column>
      <el-table-column
        prop="totalnumber"
        label="数量"
        align="left"
        header-align="center"
        width="60">
      </el-table-column>
      <el-table-column
        prop="customername"
        label="责任人"
        align="left"
        header-align="center"
        width="70">
      </el-table-column>
      <el-table-column
        prop="uname"
        label="录入人"
        align="left"
        header-align="center"
        width="80">
      </el-table-column>
      <el-table-column
        prop="adddate"
        label="报损日期"
        align="left"
        header-align="center"
        width="160">
      </el-table-column>
      <el-table-column
        label="操作" fixed="right"
        align="center" width="80">
        <template slot-scope="scope">
          <el-button
            size="mini"
            @click="view(scope.$index, scope.row)">查看
          </el-button>
        </template>
      </el-table-column>
    </el-table>
  </el-card>
  <BaoSunDetail ref="BaoSunDetail" @bindGrid="rebind"></BaoSunDetail>
</div>
</template>

<script>
    import {machiningBaosunList} from '@/api/set/jxcstoreform';
    import BaoSunDetail from './BaoSunDetail'
    export default {
      name: "baosunlist",
      data() {
        return {
          tableBaoSun: [],
          erpserial:''
        }
      },
      methods: {
        view(index,row){
           this.$refs.BaoSunDetail.show(row.erpserial);
        },
        clear(){
          this.tableBaoSun=[];
        },
        rebind(){
          this.bind(this.erpserial);
        },
        bind(erpserials) {
          this.clear();
          this.erpserial = erpserials
          if (!this.erpserial) return;
          machiningBaosunList({
            ordernums: erpserials
          }).then(response => {
            //刷新列表
            if (response.data.obj)
              this.tableBaoSun = response.data.obj
          })
        },
        getPackagesize(Packagesize) {
          if (!Packagesize || Packagesize == '') {
            return '';
          }
          var ps = JSON.parse(Packagesize);
          var rl = '';
          if (ps.type)
            rl = ps.type + '，';

          return rl + 'S：' + ps.Y + ' ， C：' + ps.X;
        }
      },
      components:{
        BaoSunDetail
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/testorder/cstagreement/BaoSunList.vue